<template>
  <span :class="['gbpro-ui-icon', tone ? `gbpro-ui-icon--${tone}` : '']" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <template v-if="name === 'download'">
        <path d="M12 4.5v9.2" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M8.2 11.3 12 15.1l3.8-3.8" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
        <path d="M6.5 18.5h11" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      </template>
      <template v-else-if="name === 'guide'">
        <path d="M6.5 5.5h11A1.5 1.5 0 0 1 19 7v12.5a1.5 1.5 0 0 0-2.2-1.3L12 16.8l-4.8 1.4A1.5 1.5 0 0 1 5 19.5V7a1.5 1.5 0 0 1 1.5-1.5Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
        <path d="M12 6.8v10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      </template>
      <template v-else-if="name === 'check'">
        <path d="M7.2 12.2 10.4 15.4 16.8 8.8" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
      </template>
      <template v-else-if="name === 'version'">
        <path d="M12 7.5V5.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M12 18.5v-2" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M16.2 8.2 18 6.4" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M7.8 15.8 6 17.6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M18.5 12A6.5 6.5 0 0 0 12 5.5 6.5 6.5 0 0 0 6.2 15" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M5.5 12H7.8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      </template>
      <template v-else-if="name === 'android'">
        <path d="M9.2 8.6 12 11.4l2.8-2.8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
        <path d="M8.5 16.5h7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M7.5 7.5h9A2.5 2.5 0 0 1 19 10v6.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 16.5V10a2.5 2.5 0 0 1 2.5-2.5Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
      </template>
      <template v-else-if="name === 'size'">
        <path d="M6.5 9.5 12 6.5l5.5 3v7L12 19.5l-5.5-3v-7Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
        <path d="M12 12.5v7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M8.8 10.8 12 12.5l3.2-1.7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />
      </template>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'GbproHeroIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => ['download', 'guide', 'check', 'version', 'android', 'size'].includes(value),
    },
    tone: {
      type: String,
      default: '',
      validator: (value) => ['', 'solid', 'glass', 'soft', 'muted'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.gbpro-ui-icon {
	--gb-ui-icon-box: 1.35em;

	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	width: var(--gb-ui-icon-box);
	height: var(--gb-ui-icon-box);
	border-radius: 999px;
	line-height: 0;

	svg {
		display: block;
		width: calc(var(--gb-ui-icon-box) * 0.58);
		height: calc(var(--gb-ui-icon-box) * 0.58);
	}
}

.gbpro-ui-icon--solid {
	background: var(--gb-green-bright);
	color: var(--gb-btn-text);
	box-shadow: 0 0 0 0.12em rgba(37, 211, 102, 0.16);
}

.gbpro-ui-icon--glass {
	background: rgba(255, 255, 255, 0.24);
	color: var(--gb-btn-text);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.gbpro-ui-icon--soft {
	background: rgba(37, 211, 102, 0.16);
	color: var(--gb-green-bright);
	box-shadow: inset 0 0 0 1px rgba(37, 211, 102, 0.22);
}

.gbpro-ui-icon--muted {
	background: rgba(255, 255, 255, 0.1);
	color: var(--gb-text);
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}
</style>
